import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiChevronDown } from 'react-icons/fi';

export default function AccordionFAQ({ items }) {
  const [openSlug, setOpenSlug] = useState(null);

  return (
    <div className="space-y-3">
      {items.map((item) => {
        const isOpen = openSlug === item.slug;

        return (
          <article key={item.slug} className="elevated rounded-2xl border border-brand-border bg-brand-surface">
            <button
              type="button"
              onClick={() => setOpenSlug((prev) => (prev === item.slug ? null : item.slug))}
              className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left"
              aria-expanded={isOpen}
            >
              <span className="text-sm font-semibold">{item.title}</span>
              <FiChevronDown className={`shrink-0 transition-transform duration-300 ease-in-out ${isOpen ? 'rotate-180' : 'rotate-0'}`} />
            </button>

            <div className={`grid transition-all duration-300 ease-in-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
              <div className="overflow-hidden">
                <div className="space-y-3 border-t border-brand-border px-4 py-4">
                  <p className="text-sm text-brand-muted">{item.summary}</p>
                  <Link to={`/faq/${item.slug}`} className="inline-block text-sm font-medium text-brand-accent">
                    Read full answer
                  </Link>
                </div>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}
